var validator = {
    data() {
        return {
            validations: []
        }
    },
    methods: {
        valid() {
            this.validations = []
            var validator = this.$options.validator

            if (validator) {
                var validator_target = this[validator.target]
                if (validator_target) {
                    for (let attribute of validator.attributes) {
                        var attribute_value = validator_target[attribute.name]
                        var localize_attribute_name = this.$t("models.attributes." + validator.localize_key + "." + attribute.name)
                        if (attribute.required) {
                            if (attribute_value === undefined || attribute_value === "" || attribute_value === null) {
                                this.validations.push(
                                    {
                                        name: attribute.name,
                                        error: localize_attribute_name + this.$t("ui.validator.is_required")
                                    }
                                )
                            }
                        }
                        if (attribute.integer_greater_than !== undefined) {
                            if (parseInt(attribute_value) <= attribute.integer_greater_than) {
                                this.validations.push(
                                    {
                                        name: attribute.name,
                                        error: localize_attribute_name + this.$t("ui.validator.greater_than") + attribute.integer_greater_than
                                    }
                                )
                            }
                        }

                        if (attribute.cases !== undefined) {
                            for (let validation_case of attribute.cases) {
                                var case_value = validator_target[validation_case.name]
                                var localize_case_name = this.$te(`models.attributes.${validator.localize_key}.${validation_case.name}`)
                                if (!localize_case_name) {
                                    localize_case_name = this.$t(`ui.pages.${validator.localize_key}.${validation_case.name}`)
                                }

                                if (attribute_value == validation_case.based_on_value) {
                                    if (validation_case.required) {
                                        if (case_value === undefined || case_value === "" || case_value === null) {
                                            this.validations.push(
                                                {
                                                    name: validation_case.name,
                                                    error: this.$t("ui.validator.if") + localize_attribute_name + this.$t("ui.validator.is") + this.$t("models.attributes." + validator.localize_key + "." + validation_case.based_on_value) + this.$t("ui.validator.then") + localize_case_name + this.$t("ui.validator.is_required")
                                                }
                                            )
                                        }
                                    }
                                    if (validation_case.integer_greater_than !== undefined) {
                                        if (parseInt(case_value) <= validation_case.integer_greater_than) {
                                            this.validations.push(
                                                {
                                                    name: validation_case.name,
                                                    error: this.$t("ui.validator.if") + localize_attribute_name + this.$t("ui.validator.is") + this.$t("models.attributes." + validator.localize_key + "." + validation_case.based_on_value) + this.$t("ui.validator.then") + localize_case_name + this.$t("ui.validator.greater_than") + validation_case.integer_greater_than
                                                }
                                            )
                                        }
                                    }
                                }
                            }
                        }
                    }

                    if (validator.input_alert) {
                        var elements = document.querySelectorAll('[data-column]')
                        for (let element of elements) {
                            element_class_list = element.classList
                            element_class_list.remove("error")
                        }

                        var validation_messages = document.getElementsByClassName("validation_message")

                        while (validation_messages[0]) {
                            validation_messages[0].parentNode.removeChild(validation_messages[0])
                        }

                        for (let validation of this.validations) {
                            var label = document.createElement("DIV")
                            label.className = "ui pointing red basic label validation_message"
                            label.textContent = validation.error
                            var elements = document.querySelectorAll('[data-column=' + validation.name + ']')
                            for (let element of elements) {
                                element_class_list = element.classList
                                element_class_list.add("error")
                                element.appendChild(label)
                            }
                        }
                    }

                    return this.validations.length > 0 ? false:true
                } else {
                    return false
                }
            } else {
                return true
            }
        }
    }
}

module.exports = validator
